import Head from "next/head";
import { useRouter } from "next/dist/client/router";
import Header from "../../components/global/header/Header";
import Project from "../../containers/Project";
import { loadPathProjects, loadProject } from "../../lib/loaders/loadProject";
import { motion } from "framer-motion";
import { ProjectContext, ProjectCtx } from "../../contexts/project";
const ProjetPage = ({ staticProjet, staticNextProject }) => {
  const router = useRouter();
  const { projet } = ProjectCtx({ staticProjet, staticNextProject });
  if (router.isFallback) return <div>Chargement ...</div>;
  if (typeof projet == {}) return <div>Chargement ...</div>;
  return (
    <ProjectContext.Provider
      value={ProjectCtx({ staticProjet, staticNextProject })}
    >
      <div>
        <Head>
          <title>
            {projet?.seo?.title ||
              "Le Projet " + projet.name + " - Axel Godefroy"}
          </title>
          <meta
            name="title"
            content={
              projet?.seo?.title ||
              "Le Projet " + projet.name + " - Axel Godefroy"
            }
          />
          <meta
            property="og:title"
            content={
              projet?.seo?.title ||
              "Le Projet " + projet.name + " - Axel Godefroy"
            }
          />
          <meta
            name="description"
            content={
              projet?.seo?.description ||
              "Découvrez mon projet " +
                projet.name +
                ", Portfolio Axel Godefroy"
            }
          />
          <meta
            property="og:description"
            content={
              projet?.seo?.description ||
              "Découvrez mon projet " +
                projet.name +
                ", Portfolio Axel Godefroy"
            }
          />

          <meta
            name="keywords"
            content={
              projet?.seo?.keywords ||
              "Développeur Web, Webdesigner, Portfolio, Étudiant, Axel Godefroy, DUT, " +
                projet.name
            }
          />
          <meta
            property="og:image"
            content={projet?.seo?.image_url || projet.image.load("thumbnail")}
          />

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                "@context": "https://schema.org",
                "@type": "Article",
                headline: projet.name,
                image: projet.image.load("thumbnail"),
                author: {
                  "@type": "Organization",
                  name: "Axel Godefroy",
                  url: "https://axelgodefroy.fr",
                },
                author: {
                  "@type": "Person",
                  name: "Axel G",
                  url: "https://axelgodefroy.fr",
                },
                publisher: {
                  "@type": "Organization",
                  name: "Axel Godefroy",
                  logo: {
                    "@type": "ImageObject",
                    url: "https://axelgodefroy.fr/img/logo.png",
                  },
                },
                datePublished: new Date(projet.createdAt)
                  .toISOString()
                  .split("T")[0],
                dateModified: new Date(projet.updatedAt)
                  .toISOString()
                  .split("T")[0],
              }),
            }}
          ></script>

          <style>
            @import url('https://fonts.googleapis.com/css2?family=Trirong:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
          </style>
        </Head>
        <Header isHome={false} />
        <motion.main
          animate={{ opacity: 1, y: 0 }}
          initial={{ opacity: 0, y: 20 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.5 }}
        >
          <Project />
        </motion.main>
      </div>
    </ProjectContext.Provider>
  );
};

export const getStaticPaths = async () => {
  if(process.env.NEXT_PUBLIC_HOST_MODE !== "portfolio" ){
    return {
        paths: [],
        fallback: false, // Enable fallback mode for dynamic routes
    }
  }else{
    const paths = await loadPathProjects();

    return {
      paths,
      fallback: false,
    };
  }

};

export const getStaticProps = async ({ params }) => {
  if(process.env.NEXT_PUBLIC_HOST_MODE !== "portfolio" ){
    return {
        notFound: true,
    };
  }

  const {
    project: staticProjet,
    nextProject: staticNextProject,
    notFound,
  } = await loadProject(params.id);

  if (notFound)
    return {
      redirect: {
        permanent: true,
        destination: "/",
      },
    };
  return {
    props: {
      staticProjet,
      staticNextProject,
    },
  };
};

export default ProjetPage;
